// extracted by mini-css-extract-plugin
module.exports = {"contentImage":"styles_contentImage__2b5SX","hiddenImage":"styles_hiddenImage__22gDi"};